import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getS3Users(hotelId) {
  const {
    host,
    URIs: { getS3Users },
  } = apiConfig;

  const uri = `${host}${getS3Users}`.replace(':hotelId', hotelId);

  return await axios.get(uri).then(res => res.data);
}
